<template>
    <div id="manageClass">
        <div class="allBodyDiv">
            <el-row class="manageClassBody" :gutter="20">
                <el-col :span="24" class="leftMember">
                    <el-card class="box-card " style="max-height: 570px;width:500px;margin:auto;position:relative">
                        <div slot="header" class="clearfix">
                            <i class="blueI" style="left: 0"></i>
                            <div style="display:inline-block">
                                <span class="cardHeader">个人中心</span>
                            </div>
                        </div>
                        <div style="margin-top:30px; " id="centerDiv">
                            <el-form label-width="130px" :model="formData">
                                <el-form-item label="昵称">
                                    <el-input style="width: 280px" v-model="formData.userInfo.nickname"></el-input>
                                </el-form-item>
                                <el-form-item label="等级">
                                    <span :style="{color:formData.userInfo.vip>0?'#e6a739':'#868585'}">
                                        {{formData.userInfo.vip>0?'VIP用户'+'(到期时间：'+formData.userInfo.vipEndTime+')':'非VIP用户'}}</span>
                                </el-form-item>
                                <el-form-item label="学校">
                                    <span>{{formData.userInfo.schoolName}}</span>
                                </el-form-item>

                                <el-form-item v-if="formData.userInfo.userType==2" label="权限容量">
                                    <span>{{formData.schoolInfo.usedNum}}/{{formData.schoolInfo.limitStudentNum}}</span>
                                    <a target="view_window" href="https://www.nobook.com/buy"><el-button class="kuorong">扩容</el-button></a>
                                </el-form-item>
                                <el-form-item v-else label="班级">
                                    <span v-if="formData.userInfo.className">{{formData.userInfo.className}}</span>
                                    <el-button v-else size="mini" @click="isjoinClass=true" type="primary">加入班级</el-button>
                                    <!--<span style="color: rgba(156, 156, 156, 0.5);font-size:12px;margin-left:15px;">如需转班请联系老师进行操作</span>-->
                                </el-form-item>
                                <el-form-item label="">
                                    <el-button @click="editInfo" type="primary" :loading="isloading"><span style="color: #fff">保存</span></el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <el-dialog title="加入班级" :visible.sync="isjoinClass" custom-class="nbDialog" width="500px">
            <div style="width: 375px;margin: auto">
                <el-form>
                    <el-form-item label="">
                        <el-input placeholder="请输入班级码" style="width: 280px" v-model="classCode">
                            <el-button @click="searchClassInfo()" slot="append" type="primary">查找</el-button>
                        </el-input>
                    </el-form-item>
                </el-form>
                <div v-if="classInfo.code==200 || classInfo.code == 0" class="classCenterInfo">
                    <el-form :model="classInfo" label-width="130px" id="infoFrom">
                        <el-form-item label="学校名称">
                            <span>{{classInfo.schoolName}}</span>
                        </el-form-item>
                        <el-form-item label="班级名称">
                            <span>{{classInfo.name}}</span>
                        </el-form-item>
                        <el-form-item label="班级编号">
                            <span>{{classInfo.classCode}}</span>
                        </el-form-item>
                        <el-form-item label="创建人">
                            <span>{{classInfo.teacherName}}</span>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button @click="joinClassF(classInfo.classCode)" type="primary"><span style="color: #fff">加入</span></el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <div v-else class="classCenterInfo">
                    <div style="color: red;text-align:center;">
                        {{classInfo.msg}}
                    </div>
                </div>

            </div>
        </el-dialog>
    </div>
</template>
<script>
    import{
        getuserinfo,
        searchclass,
        editUserInfo,
        joinclass
    } from './../../api/exam_api.js'
    import ElButton from "../../../../../node_modules/element-ui/packages/button/src/button";
    export default {
        components: {ElButton},
        data() {
            return {
                isloading:false,
                formData:{
                  nickname:'',
                  schoolInfo:{},
                  userInfo:{}
                },
                classCode:'',
                isjoinClass:false,
                classInfo:{},
            }
        },
        methods:{
            editInfo(){
this.isloading = true;
                if(this.formData.userInfo.nickname.length<2||this.formData.userInfo.nickname.length>12){
                    this.$message({
                        message: '用户昵称应在3到12位',
                        type: 'error'
                    });
                    return false
                }
                let data={
                    nickname:this.formData.userInfo.nickname,
                    userType:2
                };
                editUserInfo(data).then((res)=>{
                    if(res.code==200 || res.code==0){
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.$emit('center-data');
                        getuserinfo().then((res)=>{
                            if(res.code==200){
                                res.data.schoolInfo.vipEndTime=res.data.schoolInfo.vipEndTime?this.GLOBAL.request.toTime(res.data.schoolInfo.vipEndTime*1000,1):0;
                                this.formData=res.data
                            }
                        });
                        this.isloading = false
                        
                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        this.isloading = false
                    }
                    
                })
                
            },
            searchClassInfo(){
                searchclass({classCode:this.classCode}).then((res)=>{
                    this.classInfo=res.data;
                    this.classInfo.msg = res.msg;
                    this.classInfo.code = res.code;
                });
            },
            joinClassF(num){
                joinclass({classCode:num,pid:this.GLOBAL.pid}).then((res)=>{

                    if(res.code==200 || res.code == 0){
                        this.isjoinClass=false;
                        this.$message({
                            message: '加入班级成功',
                            type: 'success'
                        });
                       getuserinfo().then((res)=>{
                if(res.code==200 || res.code == 0){
                    // res.data.vip_endtime=res.data.vip_endtime?timestampToTime(res.data.vip_endtime*1000):0;
                    this.formData=res.data;
                }
            });
                    }else{
                        this.$message({
                            message: '加入班级失败',
                            type: 'error'
                        });
                    }
                })
                this.test();
            },
            test(){
                let pid = {pid:this.GLOBAL.pid};
            getuserinfo(pid).then((res)=>{
                if(res.code==200 || res.code == 0){
                    // res.data.vip_endtime=res.data.vip_endtime?timestampToTime(res.data.vip_endtime*1000):0;
                    this.formData=res.data;
                    // debugger
                    this.formData.userInfo.vipEndTime = this.GLOBAL.request.toTime(this.formData.userInfo.vipEndTime*1000,1)
                }
            });
            this.formData = this.GLOBAL.userInfo
            }
        },
        mounted(){
            this.test();
        }
    }
</script>
<style>
    #infoFrom .el-form-item{
        margin-bottom:10px;
    }
    #infoFrom label{
        font-size:14px;
        color: rgba(156, 156, 156, 0.6);
    }
    .classCenterInfo{
        min-height: 160px;
    }
    #centerDiv span{
        font-size:16px;
        color:#868585;
        display:inline-block;
    }
    #centerDiv button span{
        color:#fff;
    }
    #centerDiv label{
        font-size:14px;
        color: rgba(156, 156, 156, 0.6);
    }
    #centerDiv .kuorong{
        margin-left:10px;
        padding: 2px 12px;
        background-color:#d5e7ff;
        border:1px solid #d5e7ff;
        border-radius:10px;
    }
    #centerDiv .kuorong span{
        font-size:12px;
        color: #2f87ff;
    }
</style>



// WEBPACK FOOTER //
// src/assets/js/pages/exam/TeacherCenter.vue